import {MealViewModel} from './meal.viewModel';
import {MealWithDailyMealViewModel} from '../services/master.service';

export class DailyMealViewModel {
    id?: number;
    title?: string;
    meals?: MealViewModel[];
}

export class DailyMacrosViewModel {
    id: number;
    day: string;
    daily_meal_id: number;
    overwrite_all_calories: number;
    overwrite_protein: number;
    overwrite_carbs: number;
    overwrite_fat: number;
}

export class MealOverwriteViewModel {
    id: number;
    macroId: number;
    meal: MealWithDailyMealViewModel;
    overwrite_percentage: number;
}


export class MacroOverwrites {
    user_overwrite_macros: DailyMacrosViewModel[];
    meal_overwrite: MealOverwriteViewModel[];
}
